import React from "react";
import { Container, Card } from "react-bootstrap";
import { Helmet } from "react-helmet";

const PermissionDenied = () => {
  return (
    <Container fluid className="d-flex justify-content-center align-items-center vh-100 bg-black">
      <Helmet>
        <title>{`${process.env.REACT_APP_NAME} | Access Denied`}</title>
      </Helmet>
      <Card className="text-center p-4">
        <h4>Access Denied</h4>
        <p>You do not have access to the signage system.</p>
        <p>Please contact your administrator.</p>
      </Card>
    </Container>
  );
};

export default PermissionDenied;
